import { customAlphabet } from 'nanoid';
import slugify from 'slugify';

// No hyphens — publicIds are parsed from slugs by splitting on '-'
const PUBLIC_ID_ALPHABET =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_';

export const generatePublicId = customAlphabet(PUBLIC_ID_ALPHABET, 12);

const MAX_TITLE_SLUG_LENGTH = 80;

export function slugifyTitle(title: string) {
  return slugify(title, { lower: true, strict: true }).slice(
    0,
    MAX_TITLE_SLUG_LENGTH,
  );
}

/** Construct a URL slug from a title and publicId: `{slugified-title}-{publicId}` */
export function buildSlug(title: string | null, publicId: string) {
  if (!title) return publicId;
  const titleSlug = slugifyTitle(title);
  return titleSlug ? `${titleSlug}-${publicId}` : publicId;
}

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Extract the publicId from a slug, raw UUID, or raw MongoDB ObjectId.
 * Slug format: `some-title-{publicId}` → returns `{publicId}`.
 */
export function parsePublicIdFromSlug(slug: string) {
  const normalized = slug.replace(/\/+$/, '');

  // Raw UUID — return as-is (resolved by audio.id, not publicId)
  if (UUID_RE.test(normalized)) return normalized;

  // Slug format: split on '-' and take the last segment
  const publicId = normalized.split('-').at(-1);
  if (!publicId) throw new Error('Invalid audio slug');
  return publicId;
}
